import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { totpSetup, ApiError } from '../lib/api'
import { AuthLayout, ErrorBox, Field, SubmitButton } from '../components/AuthLayout'

// Step 1 of TOTP enrolment: prove you still are who the session says you are before a new
// second factor gets planted on the account (see pkg/api/totp.go's header comment — a
// session cookie alone must not be enough, a stolen cookie should not let an attacker
// lock the real owner out by enrolling their own device).
export function TotpSetupPassword() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await totpSetup.start(password)
      navigate('/totp/setup/confirm')
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Wachtwoord klopt niet.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Bevestig je wachtwoord">
      <ErrorBox>{error}</ErrorBox>
      <p className="mb-4 text-sm text-ink-soft">Voer je wachtwoord opnieuw in om tweestapsverificatie in te schakelen.</p>
      <form onSubmit={onSubmit}>
        <Field
          label="Wachtwoord"
          type="password"
          required
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <SubmitButton disabled={busy}>Doorgaan</SubmitButton>
      </form>
    </AuthLayout>
  )
}
